const VENDOR_ENDPOINTS = {
  LOGIN_VENDOR: 'api_s/login_vendor',
  REGISTER_VENDOR: 'api_s/register_vendor',
  GET_PROFILE_VENDOR: 'api_s/get_profile_vendor',
  LIST_BUSINESS_VENDOR: 'api_s/list_business_vendor',
  ADD_BUSINESS_VENDOR: 'api_s/add_business_vendor',
  EDIT_BUSINESS_VENDOR: 'api_s/edit_business_vendor',
  UPDATE_BUSINESS_VENDOR: 'api_s/update_business_vendor',
  UPDATE_BUSINESS_CONTACT_VENDOR: 'api_s/update_business_contact_vendor',
  UPDATE_BUSINESS_DOCUMENTS_VENDOR: 'api_s/update_business_documents_vendor',
  UPDATE_BUSINESS_BANK_VENDOR: 'api_s/update_business_bank_vendor',
  DELETE_BUSINESS_VENDOR: 'api_s/delete_business_vendor',
  ADD_VENDOR_BUSINESS_VENUE: 'api_s/add_vendor_business_venue',
  GET_VENUE_HIGHLIGHTS: 'api_s/get_venue_highlights',
  GET_VENUE_TYPES: 'api_s/get_venue_types',
  GET_VENUE_EVENTS_HOSTED: 'api_s/get_venue_events_hosted',
  GET_VENUE_AMENITIES: 'api_s/get_venue_amenities',
  GET_VENUE_INHOUSE_SERVICES: 'api_s/get_venue_inhouse_services',
  GET_SERVICE_VENDOR_CATEGORIES: 'api_s/get_service_vendor_categories',
  LIST_VENUES_BUSINESS_VENDOR: 'api_s/list_venues_business_vendor',
  UPDATE_VENDOR_VENUE_DETAILS: 'api_s/update_vendor_venue_details',
  PUBLISH_VENDOR_VENUE_DETAILS: 'api_s/publish_vendor_venue_details',
  ADD_PACKAGE_VENUE: 'api_s/add_package_venue',
  UPDATE_PACKAGE_VENUE: 'api_s/update_package_venue',
  EDIT_PACKAGE_VENUE: 'api_s/edit_package_venue',
  GET_PACKAGES_VENUE: 'api_s/get_packages_venue',
  DELETE_PACKAGE_VENUE: 'api_s/delete_package_venue',
  ADD_POLICIES_VENUE: 'api_s/add_policies_venue',
  EDIT_POLICIES_VENUE: 'api_s/edit_policies_venue',
  ADD_VENUE_VENDOR_PARTNER: 'api_s/add_venue_vendor_partner',
  UPDATE_VENUE_VENDOR_PARTNER: 'api_s/update_venue_vendor_partner',
  LIST_VENUE_VENDOR_PARTNERS: 'api_s/list_venue_vendor_partners',
  DELETE_VENUE_VENDOR_PARTNER: 'api_s/delete_venue_vendor_partner',
  GET_VENUE_GALLERY_CATEGORIES: 'api_s/get_venue_gallery_categories',
  GET_VENUE_GALLERY: 'api_s/get_venue_gallery',
  ADD_VENUE_GALLERY: 'api_s/add_venue_gallery',
  DELETE_VENUE_GALLERY: 'api_s/delete_venue_gallery',
  UPDATE_VENUE_COVER_IMAGE: 'api_s/update_venue_cover_image',
  GET_VENUE_META_DETAILS: 'api_s/get_venue_meta_details',
  UPDATE_VENUE_META_DETAILS: 'api_s/update_venue_meta_details',
  GET_VENUE_AVAILABILITY: 'api_s/get_venue_availability',
  UPDATE_AVAILABILITY_VENUE: 'api_s/update_availability_venue',
  GET_SPACE_GALLERY: 'api_s/get_space_gallery',
  ADD_SPACE_GALLERY: 'api_s/add_space_gallery',
  GET_VENUE_SPACE_TYPES: 'api_s/get_venue_space_types',
  GET_VENUE_SPACE_SEAT_CONFIG: 'api_s/get_venue_space_seat_config',
  ADD_VENUE_SPACE: 'api_s/add_venue_space',
  UPDATE_VENUE_SPACE: 'api_s/update_venue_space',
  DELETE_VENUE_SPACE: 'api_s/delete_space_venue',
  LIST_VENUE_SPACES: 'api_s/list_venue_spaces',
  ADD_VENUE: 'api_s/add_venue',
  UPDATE_VENUE: 'api_s/update_venue',
  DELETE_VENUE: 'api_s/delete_venue',
  LIST_VENDOR_PACKAGES: 'api_s/list_vendor_packages',
  ADD_VENDOR_PACKAGE: 'api_s/add_vendor_package',
  DELETE_VENDOR_PACKAGE: 'api_s/delete_vendor_package',
  UPDATE_VENDOR_PACKAGE: 'api_s/update_vendor_package',
  GET_SUBCATEGORIES: 'api_s/get_subcategories',
}

export default VENDOR_ENDPOINTS
